import React from "react";
import InformationTooltip from "../Tooltips/InformationTooltip";

const SwitchButton = ({
    label,
    checked,
    tooltip,
    onChange,
    className = "",
    required = false,
}) => {
    return (
        <>
            <div className={`input-group ${className}`}>
                <div className="flex">
                    {label && (
                        <label
                            className={`uppercase text-xs ${
                                required ? "required" : ""
                            }`}
                        >
                            {label}
                        </label>
                    )}
                    {tooltip && (
                        <InformationTooltip
                            message={tooltip}
                            className="ml-1 fa-xs"
                        />
                    )}
                </div>

                <div className="relative">
                    <input
                        type="checkbox"
                        className="sr-only"
                        checked={checked}
                        readOnly
                    />
                    <div className="w-10 h-4 bg-gray-100 rounded-full shadow-inner"></div>
                    <div
                        className="dot absolute w-6 h-6 bg-white rounded-full shadow -left-1 -top-1 transition cursor-pointer"
                        onClick={onChange}
                    ></div>
                </div>
            </div>
        </>
    );
};

export default SwitchButton;
